import React from "react";
import styles from "./Onboarding.module.css";

const StepWelcome = ({ intent, setIntent, onNext }) => {
  return (
    <>
      <h1 className={styles.heading}>Welcome to Authkey!</h1>

      <p className={styles.subheading}>
        Let's get you started. A couple of questions will help us tailor your experience.
      </p>

      <label className={styles.label}>
        What brings you to Authkey? What are you hoping to build or achieve?
      </label>

      <textarea
        className={styles.textarea}
        placeholder="e.g. I want to send OTPs via SMS for my app..."
        value={intent}
        onChange={(e) => setIntent(e.target.value)}
      />

      <div className={styles.actionsRight}>
        <button
          className={styles.primaryBtn}
          disabled={!intent.trim()}
          onClick={onNext}
        >
          Next →
        </button>
      </div>
    </>
  );
};

export default StepWelcome;
